import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class UserFormService {

  user_form = '/assets/mockdata/UserForm_sectionwise.json'
  backend_user_form = '/assets/mockdata/User_Form.json'


  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getUserForm() {
    return this.http.get(this.user_form);
  }

  getBackendUserForm() {
    return this.http.get(this.backend_user_form);
  }

  saveData(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.MANUAL_ENTRY_API.MANUAL_EDIT_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
